import { render, staticRenderFns } from "./CertificadoPrecancelacionFileButton.vue?vue&type=template&id=11b4889a&scoped=true"
import script from "./CertificadoPrecancelacionFileButton.vue?vue&type=script&lang=js"
export * from "./CertificadoPrecancelacionFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4889a",
  null
  
)

export default component.exports